import * as React from 'react';

import type { InstructorsProcessingRequestsContextValue } from './InstructorsProcessingRequestsContext.types';

import { InstructorsProcessingRequestsContext } from './InstructorsProcessingRequestsProvider';

export function useInstructorsProcessingRequests(): InstructorsProcessingRequestsContextValue {
  const context = React.useContext(InstructorsProcessingRequestsContext);
  if (!context) {
    throw new Error(
      'useInstructorsProcessingRequests must be used within InstructorsProcessingRequestsProvider'
    );
  }
  return context;
}
